




import { Component, Vue, Watch } from 'vue-property-decorator'
import ExceptionPage from './ExceptionPage.vue'

@Component({
	components: {
		ExceptionPage,
	},
})
export default class Page404 extends Vue {}
